import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import WebApp from "@twa-dev/sdk";

import { NavBar } from "./components/NavBar";
import { PlansScreen } from "./screens/PlansScreen";
import { CheckoutScreen } from "./screens/CheckoutScreen";
import { MySubscriptionScreen } from "./screens/MySubscriptionScreen";
import { DevicesScreen } from "./screens/DevicesScreen";
import { PaymentsScreen } from "./screens/PaymentsScreen";
import { PromoScreen } from "./screens/PromoScreen";
import { CancelScreen } from "./screens/CancelScreen";
import { StubScreen } from "./screens/StubScreen";
import "./i18n";

export function App() {
  useEffect(() => {
    WebApp.ready();
    WebApp.expand();
  }, []);

  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<PlansScreen />} />
        <Route path="/checkout/:planId" element={<CheckoutScreen />} />
        <Route path="/subscription" element={<MySubscriptionScreen />} />
        <Route path="/devices" element={<DevicesScreen />} />
        <Route path="/change-plan" element={<StubScreen titleKey="change_plan_title" />} />
        <Route path="/payments" element={<PaymentsScreen />} />
        <Route path="/cancel" element={<CancelScreen />} />
        <Route path="/promo" element={<PromoScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
